import { render, staticRenderFns } from "./IncUserData.vue?vue&type=template&id=f50bb364"
import script from "./IncUserData.vue?vue&type=script&lang=js"
export * from "./IncUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports